import gql from 'graphql-tag';

export const AVERAGE_ANNUAL_TOTAL_RETURNS = gql`
    query AverageAnnualTotalReturns($ticker: String!) {
        mutualFund(ticker: $ticker) {
            inceptionDate
            tackedReturnFundInceptionDate
            standardPerformanceReturns {
                quarterlyAnnualReturns {
                    fundPerformance {
                        asOfDate
                        oneYearReturn
                        threeYearReturn
                        fiveYearReturn
                        tenYearReturn
                        sinceInceptionReturn
                        cumulativeSinceInceptionReturn
                        oneYearReturnTacked
                        threeYearReturnTacked
                        fiveYearReturnTacked
                        tenYearReturnTacked
                        sinceInceptionReturnTacked
                    }
                }
                monthlyAnnualReturns {
                    fundPerformance {
                        asOfDate
                        oneYearReturn
                        threeYearReturn
                        fiveYearReturn
                        tenYearReturn
                        sinceInceptionReturn
                        cumulativeSinceInceptionReturn
                        oneYearReturnTacked
                        threeYearReturnTacked
                        fiveYearReturnTacked
                        tenYearReturnTacked
                        sinceInceptionReturnTacked
                    }
                }
            }
        }
    }
`;

// TODO - add correct query once data mapping is done
export const AVERAGE_ANNUAL_TOTAL_RETURNS_FEES_EXPENSES = gql`
    query AverageAnnualTotalReturnsFeesExpenses($ticker: String!) {
        mutualFund(ticker: $ticker) {
            activeMoneyMarketFundMessages {
                message
            }
            dailyYTDTotalReturns {
                fundReturn
                asOfDate
            }
            standardPerformanceReturns {
                threeMonthReturn {
                    fundReturn
                    asOfDate
                }
            }
            inceptionDate
            Strategy: strategyText
            grossExpenseRatio
            netExpenseRatio
            expenseRatioWaiverType
            transactionFee
            fee121b
            expenseRatioWaiverExpirationDate
        }
    }
`;
